import routes from '../routes';
import reducer from './reducers/index';
import * as BcSelectors from './selectors';
import * as BcOperations from './operations';
import * as BcActions from './actions';

export {
    BcSelectors,
    BcOperations,
    BcActions
};

export default {
    routes,
    reducer
};
